module.exports = __webpack_public_path__ + "img/red_sunset.998ebb5c.svg";